import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { filter, map, Observable } from 'rxjs';
import { AppState } from 'src/app/reducers';
import { Contenido } from 'src/common/contenido';
import { detalleCleared, detalleEmergenciaRequested } from '../../store/detalle/detalle.actions';
import { detalleReady, detalleSelected } from '../../store/detalle/detalle.selectors';

@Component({
	selector: 'app-emergencia',
	templateUrl: './emergencia.component.html',
	styleUrls: ['./emergencia.component.scss'],
	encapsulation: ViewEncapsulation.None	// para poder tener reglas css en el html del detalle
})
export class EmergenciaComponent implements OnInit, OnDestroy {

	detalle$: Observable<Contenido>;
	ready$: Observable<boolean>;


	constructor( private store: Store<AppState>, private sanitizer: DomSanitizer ) {
	}

	ngOnInit(): void {
		this.store.dispatch( detalleEmergenciaRequested() );
		this.detalle$ = this.store.select( detalleSelected ).pipe(
			filter( detalle => detalle != null && detalle.detalle != null ),
			map( detalle => {
				return { ...detalle, html: this.sanitizer.bypassSecurityTrustHtml( detalle.detalle ) }
			} )
		);
		this.ready$ = this.store.select( detalleReady );
	}

	ngOnDestroy(): void {
		this.store.dispatch( detalleCleared() );
	}

}
